import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import type * as Payor from './models/payor.js';

export class API {
  common: Common;
  baseEndpoint = '/payors';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<Payor.FindAllOptions>
  ): Promise<PaginationResponse<Payor.Payor>> {
    const url = this.common.constructPath(this.baseEndpoint, { ...options, populated: true });
    return await this.common.getJSON(url);
  }

  async findAll(query: Payor.FindAllOptions = {}): Promise<Payor.Payor[]> {
    const url = this.common.constructPath(this.baseEndpoint, {
      ...query,
      populated: true,
    });
    return await this.common.getJSON(url);
  }

  async findAllPayors(query: Payor.FindAllOptions = {}): Promise<string[]> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    const res: Payor.Payor[] = await this.common.getJSON(url);
    const payors = res.map((payor) => payor.name);
    return payors;
  }

  async findOneById(id: string): Promise<Payor.Payor> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`, { populated: true });
    return await this.common.getJSON(url);
  }

  async create(values: Payor.CreateValues): Promise<Payor.Payor> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: Payor.UpdateValues): Promise<Payor.Payor> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
